import { render, staticRenderFns } from "./page-sider.vue?vue&type=template&id=6480145e&scoped=true"
import script from "./page-sider.vue?vue&type=script&lang=js"
export * from "./page-sider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6480145e",
  null
  
)

export default component.exports